import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { isEmpty, uniqueId } from 'lodash';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/messages';
import { translate } from 'containers/services/translate';
import { StyledCivilParty } from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/styled-components';
import AddEmptyJudgementBloc from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/AddEmptyCivilParty';
import AddCivilParty from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/AddCivilParty';
import CivilPartyRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/CivilPartyRecap';
import {
  CivilParty as ICivilParty,
  CIVIL_PARTY_FORM,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty/constants';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { VictimType } from 'typings/globalTypes';
export interface CivilPartyProps {
  intl: IntlShape;
  victims: VictimType[];
  uploadDocument: Function;
  civilPartyDocuments: ICivilParty[];
  setCivilPartyDocuments: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  canStartCivilParty: boolean;
  sagisVictimInfo: any;
  isBasicManagement?: boolean;
  imagineDocuments: any;
  policyInfo: any;
  listings: any;
  requestGetDocByDocumentumId: Function;
}

const CivilParty: React.FC<CivilPartyProps> = (props): JSX.Element => {
  const [form, setForm] = React.useState(
    !isEmpty(props.civilPartyDocuments) && props.isBasicManagement
      ? CIVIL_PARTY_FORM.RECAP
      : CIVIL_PARTY_FORM.EMPTY,
  );

  const handleAddClick = () => {
    setForm(CIVIL_PARTY_FORM.IN_WRITING);
  };

  const deleteCivilParty = (index: number) => () => {
    const civilParties = props.civilPartyDocuments.filter(
      (_, i) => i !== index,
    );

    props.setCivilPartyDocuments(civilParties);
    if (isEmpty(civilParties)) setForm(CIVIL_PARTY_FORM.EMPTY);
  };

  return (
    <StyledCivilParty>
      <div className="civil_party">
        <div className="title-div">
          <span className="title">
            {translate(messages.civilPartyBlocTitle, props)}
          </span>
          {form === CIVIL_PARTY_FORM.RECAP && (
            <PrimaryButton
              onClick={handleAddClick}
              lefticon={<AddCircleOutlineIcon className="icon" />}
              title={translate(messages.addButton, props)}
              className="add-new-civil-party-style"
            />
          )}
        </div>
        {form === CIVIL_PARTY_FORM.EMPTY && (
          <AddEmptyJudgementBloc addCivilParty={setForm} />
        )}
        {form === CIVIL_PARTY_FORM.IN_WRITING && (
          <AddCivilParty
            victims={props.victims}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setCivilPartyDocuments={props.setCivilPartyDocuments}
            civilPartyDocuments={props.civilPartyDocuments}
            addCivilParty={setForm}
            resetUploadedDocument={props.resetUploadedDocument}
            sagisVictimInfo={props.sagisVictimInfo}
            isBasicManagement={props.isBasicManagement}
          />
        )}
        {!isEmpty(props.civilPartyDocuments) &&
          props.civilPartyDocuments.map((civilParty, index) => (
            <CivilPartyRecap
              key={uniqueId('recap-')}
              civilParty={civilParty}
              deleteCivilParty={deleteCivilParty(index)}
              index={index}
              sagisVictimInfo={props.sagisVictimInfo}
              isBasicManagement={props.isBasicManagement}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          ))}
      </div>
    </StyledCivilParty>
  );
};

export default injectIntl(CivilParty);
export { CivilParty as CivilPartyComponent };
